import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, FileText, Star } from 'lucide-react';
import { Button } from '../components/ui/Button';

export const LandingPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="pt-20 pb-32 px-4 bg-gradient-to-b from-white to-blue-50">
        <div className="container mx-auto max-w-6xl text-center">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-700 font-medium text-sm mb-8">
            <Star size={16} className="mr-2 fill-blue-700" />
            Rated #1 Free Resume Builder
          </div>
          <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 tracking-tight mb-8 leading-tight">
            Build a Professional Resume with <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
              CareerCanvas
            </span>
          </h1>
          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            Create a polised, ATS-friendly resume with our easy-to-use builder. 
            No sign-up required. Choose a template, enter your details, and download PDF.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/templates">
              <Button size="lg" className="w-full sm:w-auto px-8 py-4 text-lg shadow-lg shadow-blue-500/30 hover:shadow-blue-500/40 transition-all">
                Create My Resume <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>

          <div className="mt-16 flex items-center justify-center gap-8 text-gray-500 text-sm font-medium">
            <div className="flex items-center"><CheckCircle size={18} className="text-green-500 mr-2" /> No Account Needed</div>
            <div className="flex items-center"><CheckCircle size={18} className="text-green-500 mr-2" /> Free PDF Download</div>
            <div className="flex items-center"><CheckCircle size={18} className="text-green-500 mr-2" /> ATS-Friendly</div>
          </div>
        </div>
      </section>

      {/* Feature Preview Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
           <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-200 bg-gray-50 mx-auto max-w-5xl aspect-[16/9] flex items-center justify-center p-8">
              
              {/* Mock App Interface */}
              <div className="w-full h-full bg-white rounded-xl shadow-lg border border-gray-200 flex overflow-hidden">
                  {/* Mock Sidebar */}
                  <div className="w-64 bg-white border-r border-gray-100 hidden md:flex flex-col p-4 gap-4">
                      <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse"></div>
                      <div className="h-8 w-full bg-blue-50 rounded-lg border border-blue-100 mb-4"></div>
                      
                      <div className="space-y-4">
                          {[1,2,3].map(i => (
                              <div key={i} className="flex flex-col gap-2">
                                  <div className="h-3 w-1/3 bg-gray-100 rounded"></div>
                                  <div className="h-8 w-full bg-gray-50 rounded border border-gray-100"></div>
                              </div>
                          ))}
                      </div>
                  </div>

                  {/* Mock Preview Area */}
                  <div className="flex-1 bg-gray-100 p-8 flex justify-center items-start overflow-hidden">
                      <div className="w-[180mm] h-[250mm] bg-white shadow-xl rounded-sm p-8 transform scale-75 origin-top">
                          <div className="border-b-2 border-gray-800 pb-4 mb-6">
                              <div className="h-10 w-1/2 bg-gray-800 rounded mb-2"></div>
                              <div className="h-4 w-1/3 bg-gray-400 rounded"></div>
                          </div>
                          
                          <div className="space-y-6">
                              {[1,2,3,4].map(i => (
                                  <div key={i}>
                                      <div className="h-4 w-1/4 bg-gray-300 rounded mb-2"></div>
                                      <div className="space-y-2">
                                          <div className="h-3 w-full bg-gray-100 rounded"></div>
                                          <div className="h-3 w-5/6 bg-gray-100 rounded"></div>
                                      </div>
                                  </div>
                              ))}
                          </div>
                      </div>
                  </div>
              </div>

           </div>
        </div>
      </section>
    </div>
  );
};
